import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiInstagram,FiFacebook,FiArrowUpRight} = FiIcons;
const waLink = (t) => `https://wa.me/919876543210?text=${encodeURIComponent(t)}`;
const WA = 'https://wa.me/919876543210?text=Hi%20Aurelle!';

function SiteFooter() {
  return (
    <footer className="bg-[#15302A] px-6 md:px-12 lg:px-20 pt-20 pb-8">
      <div className="max-w-7xl mx-auto grid md:grid-cols-[1.3fr_1fr_1fr_1fr] gap-10 pb-14">
        <div>
          <a href="#home" className="font-display text-3xl tracking-[0.15em] text-[#F7F2EA]">AURELLE</a>
          <p className="mt-5 max-w-xs font-display text-lg italic text-[#B87333]">Wear what feels like you.</p>
          <div className="mt-6 flex gap-3">
            <a href={WA} target="_blank" rel="noreferrer" aria-label="Instagram" className="grid place-items-center w-10 h-10 rounded-full bg-[#1F3D2E] text-[#B87333] hover:bg-[#B87333] hover:text-[#1F1B17] transition"><SafeIcon icon={FiInstagram} /></a>
            <a href={WA} target="_blank" rel="noreferrer" aria-label="Facebook" className="grid place-items-center w-10 h-10 rounded-full bg-[#1F3D2E] text-[#B87333] hover:bg-[#B87333] hover:text-[#1F1B17] transition"><SafeIcon icon={FiFacebook} /></a>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-[#B87333]">Explore</span>
          <a href={waLink('I would like to see new arrivals.')} target="_blank" rel="noreferrer" className="font-sans text-sm text-[#F7F2EA]/70 hover:text-[#B87333] transition w-fit">New arrivals</a>
          <a href={waLink('I would love to browse dresses.')} target="_blank" rel="noreferrer" className="font-sans text-sm text-[#F7F2EA]/70 hover:text-[#B87333] transition w-fit">Dresses &amp; occasion</a>
          <a href={waLink('Please share your accessories.')} target="_blank" rel="noreferrer" className="font-sans text-sm text-[#F7F2EA]/70 hover:text-[#B87333] transition w-fit">Accessories</a>
        </div>
        <div className="flex flex-col gap-4">
          <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-[#B87333]">Concierge</span>
          <a href={waLink('I would like to book a styling appointment.')} target="_blank" rel="noreferrer" className="font-sans text-sm text-[#F7F2EA]/70 hover:text-[#B87333] transition w-fit">Book appointment</a>
          <a href={waLink('I need help with sizing.')} target="_blank" rel="noreferrer" className="font-sans text-sm text-[#F7F2EA]/70 hover:text-[#B87333] transition w-fit">Size &amp; fit advice</a>
          <a href={WA} target="_blank" rel="noreferrer" className="font-sans text-sm text-[#B87333] inline-flex items-center gap-2 w-fit">Order on WhatsApp <SafeIcon icon={FiArrowUpRight} className="text-xs" /></a>
        </div>
        <div className="flex flex-col gap-4">
          <span className="font-sans text-[10px] tracking-[0.25em] uppercase text-[#B87333]">Visit</span>
          <p className="font-sans text-sm text-[#F7F2EA]/70">14 Heritage Lane<br />Bandra West,Mumbai 400050</p>
          <a href={WA} target="_blank" rel="noreferrer" className="font-sans text-sm text-[#B87333]">+91 98765 43210</a>
        </div>
      </div>
      <div className="border-t border-[#1F3D2E] pt-6 flex flex-wrap items-center justify-between gap-3 font-sans text-[10px] tracking-[0.2em] uppercase text-[#B87333]/60">
        <span>© 2025 Aurelle Boutique</span>
        <span>Crafted with care in India</span>
        <a href="#home" className="text-[#B87333]">Back to top ↑</a>
      </div>
    </footer>
  );
}

export default SiteFooter;
